/* eslint-disable no-case-declarations */
import moment from "moment";
import _ from "lodash";
import React from "react";
import Reflux from "reflux";
import { Redirect } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { auth } from "../utils/firebaseUtils";
import { withTranslation } from "react-i18next";
import logger from "../utils/LoggerFrontend";
import Actions from "../Actions";
import StatusStore from "../Stores/StatusStore";
import { Store__System, CustomerSucessController } from "@talentbait/shared-components";
import LoadingView from "../Components/LoadingView";
import { formatIntlNumber } from "../utils/Helpers";

const PREPAID_TRANSACTION_TYPES = {
  TOP_UP: "topUp",
  BOOK_CAMPAIGN: "bookCampaign",
  TRANSFER: "transfer"
};

class PrepaidBilling extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingOrga: true,
      isLoadingPrepaidTransactions: false,
      invoiceAddresses: undefined,
      campaigns: undefined,
      bookedInvoices: undefined,
      sortedPrepaidTransactions: undefined,
      orgaData: undefined
    };
    this.stores = [Store__System, StatusStore];

    Actions.getPrepaidTransactions.completed.listen((result) => {
      logger.debug("Billing:loadInvoices:completed", "called...", { result });

      const { payload } = result;

      this.setState({
        isLoadingPrepaidTransactions: false,
        invoiceAddresses: payload.invoiceAddresses || [],
        campaigns: payload.campaigns || [],
        bookedInvoices: payload.bookedInvoices || [],
        sortedPrepaidTransactions: payload.sortedPrepaidTransactions || []
      });
    });

    Actions.getPrepaidTransactions.failed.listen((err) => {
      logger.debug("Billing:loadInvoices:failed", "called...", err);
      this.setState({
        isLoadingPrepaidTransactions: false
      });
    });

    this.loadHandler = Actions.loadOrganization.completed.listen((orga) => {
      logger.debug("Billing:loadHandler:completed", "called...", orga);
      Actions.getPrepaidTransactions(orga.id);

      this.setState({ isLoadingOrga: false, isLoadingPrepaidTransactions: true, orgaData: orga });
    });

    this.loadHandlerFailed = Actions.loadOrganization.failed.listen(() => {
      logger.debug("Billing:loadHandler:failed", "called...");
      this.setState({ isLoadingOrga: false });
    });

    logger.debug("Billing:constructor", "called...", props.match.params.orgaId);

    Actions.loadOrganization(props.match.params.orgaId);
  }
  componentWillUnmount() {
    this.loadHandler();
    this.loadHandlerFailed();
  }
  componentDidMount() {
    // TODO: what is this?
    CustomerSucessController.send("Settings:billing");
  }
  getPDF(id, e) {
    ///api/sales/invoices/:id/pdf/v1
    logger.debug("Billing:getPDF", "called...");
    Actions.getInvoiceAsPDF(id);
  }
  renderDesc(text) {
    text = text.replace("Social Media Booster für die Stellenanzeige", "");
    text = text.replace("der Firma: ", "");
    text = text.replace("über 30 Tage", "");

    return text.slice(0, 100) + "...";
  }
  openInvoice(invoiceId, e) {
    e.preventDefault();

    auth.currentUser.getIdToken(true).then(function (idToken) {
      window.open(`/api/v1/invoicing/invoices/${invoiceId}/pdf?idToken=${idToken}`);
    });
  }
  getPrepaidTransactionInvoiceAddress(prepaidTransaction) {
    let invoiceAddress;

    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        invoiceAddress = this.state.invoiceAddresses.find(
          (invoiceAddress) => invoiceAddress.id === prepaidTransaction.invoiceAddressId
        );
        return invoiceAddress;

      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        const campaign = this.state.campaigns.find(
          (campaign) => campaign.id === prepaidTransaction.campaignId
        );
        invoiceAddress = this.state.invoiceAddresses.find(
          (invoiceAddress) => invoiceAddress.id === campaign?.invoicing?.organizationId
        );
        return invoiceAddress;
    }

    return invoiceAddress;
  }
  getPrepaidTransactionFirmName(prepaidTransaction) {
    const invoiceAddress = this.getPrepaidTransactionInvoiceAddress(prepaidTransaction);

    if (!invoiceAddress?.name) {
      return "-";
    }

    return invoiceAddress.name;
  }
  getPrepaidTransactionAmountSpent(prepaidTransaction) {
    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        return parseFloat(prepaidTransaction.amount);

      case PREPAID_TRANSACTION_TYPES.TRANSFER:
        if (prepaidTransaction.fromOrganizationId === this.state.orgaData.id) {
          return parseFloat(prepaidTransaction.amount);
        }
        return 0;

      default:
        return 0;
    }
  }
  getPrepaidTransactionAmountUploaded(prepaidTransaction) {
    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        return parseFloat(prepaidTransaction.amount);

      case PREPAID_TRANSACTION_TYPES.TRANSFER:
        if (prepaidTransaction.fromOrganizationId !== this.state.orgaData.id) {
          return parseFloat(prepaidTransaction.amount);
        }
        break;

      default:
        return 0;
    }
  }
  getPrepaidTransactionBookedInvoice(prepaidTransaction) {
    let bookedInvoice;

    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        bookedInvoice = this.state.bookedInvoices.find(
          (bookedInvoice) => bookedInvoice.id === prepaidTransaction.bookedInvoiceId
        );
        break;
      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        const campaign = this.state.campaigns.find(
          (campaign) => campaign.id === prepaidTransaction.campaignId
        );
        bookedInvoice = this.state.bookedInvoices.find(
          (bookedInvoice) => bookedInvoice.id === campaign?.bookedInvoiceId
        );
        break;
    }

    return bookedInvoice;
  }
  isPrepaidTransactionPaid(prepaidTransaction) {
    if (prepaidTransaction.type !== PREPAID_TRANSACTION_TYPES.TOP_UP) {
      return true;
    }

    const bookedInvoice = this.state.bookedInvoices.find(
      (bookedInvoice) => bookedInvoice.id === prepaidTransaction.bookedInvoiceId
    );

    const isPaid = bookedInvoice?.paid;

    return isPaid;
  }
  getPrepaidTransactionAmountUnpaid(prepaidTransaction) {
    if (prepaidTransaction.type === PREPAID_TRANSACTION_TYPES.TOP_UP) {
      const isPaid = this.isPrepaidTransactionPaid(prepaidTransaction);
      if (!isPaid) {
        return parseFloat(prepaidTransaction.amount);
      }
    }

    return 0;
  }
  renderPrepaidTransactionUserName(prepaidTransaction) {
    return prepaidTransaction.userName || "-";
  }
  renderPrepaidTransactionInvoice(prepaidTransaction) {
    const firmName = this.getPrepaidTransactionFirmName(prepaidTransaction);
    const bookedInvoice = this.getPrepaidTransactionBookedInvoice(prepaidTransaction);
    if (!bookedInvoice?.id) {
      return firmName;
    }

    return (
      <button className="button_as_a_tag" onClick={this.openInvoice.bind(this, bookedInvoice.id)}>
        {firmName}
      </button>
    );
  }
  renderPrepaidTransactionType(prepaidTransaction) {
    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        return "Top up";
      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        return `Campaign booking [${prepaidTransaction.campaignId}]`;
      case PREPAID_TRANSACTION_TYPES.TRANSFER:
        if (prepaidTransaction.fromOrganizationId === this.state.orgaData.id) {
          return `Credits transfered from ${
            prepaidTransaction.fromOrganizationName || prepaidTransaction.fromOrganizationId
          }`;
        }
        return `Credits transfered to ${
          prepaidTransaction.toOrganizationName || prepaidTransaction.toOrganizationId
        }`;
      default:
        return "";
    }
  }
  renderPrepaidTransactionAmount(prepaidTransaction) {
    let amountText = "";

    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        amountText = `+${parseFloat(prepaidTransaction.amount).toFixed(2)}`;
        break;
      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        amountText = `-${parseFloat(prepaidTransaction.amount).toFixed(2)}`;
        break;
      case PREPAID_TRANSACTION_TYPES.TRANSFER:
        if (prepaidTransaction.fromOrganizationId === this.state.orgaData.id) {
          // Deduct because it was sent
          amountText = `-${parseFloat(prepaidTransaction.amount).toFixed(2)}`;
        } else {
          // Add because it was received
          amountText = `+${parseFloat(prepaidTransaction.amount).toFixed(2)}`;
        }
        break;
      default:
        return "";
    }

    return formatIntlNumber(amountText, { language: this.state.userProfile?.language }) + " €";
  }
  getStatusToRender(status) {
    const { t } = this.props;
    const statusesToRender = {
      paid: <span className="paid">{t("Paid")}</span>,
      unpaid: <span className="unpaid">{t("Unpaid")}</span>,
      pending: <span className="pending">{t("Pending")}</span>
    };

    return statusesToRender[status];
  }
  hasPrepaidTransactionCampaignBeenLive(prepaidTransaction) {
    if (prepaidTransaction.type !== PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN) {
      return false;
    }

    const campaign = this.state.campaigns.find(
      (campaign) => campaign.id === prepaidTransaction.campaignId
    );

    return Boolean(campaign?.campaignLiveDate);
  }
  renderPrepaidTransactionState(prepaidTransaction) {
    switch (prepaidTransaction.type) {
      case PREPAID_TRANSACTION_TYPES.TOP_UP:
        const isPaid = this.isPrepaidTransactionPaid(prepaidTransaction);
        if (isPaid) {
          return this.getStatusToRender("paid");
        }
        return this.getStatusToRender("unpaid");
      case PREPAID_TRANSACTION_TYPES.BOOK_CAMPAIGN:
        const hasBeenLive = this.hasPrepaidTransactionCampaignBeenLive(prepaidTransaction);
        if (hasBeenLive) {
          return this.getStatusToRender("paid");
        }
        return this.getStatusToRender("pending");
      case PREPAID_TRANSACTION_TYPES.TRANSFER:
        return this.getStatusToRender("paid");
      default:
        return "-";
    }
  }
  renderRows(sortedPrepaidTransactionsList) {
    this.amountSpent = 0;
    this.amountUploaded = 0;
    this.amountUnpaid = 0;

    return _.map(sortedPrepaidTransactionsList, (prepaidTransaction) => {
      const key = prepaidTransaction.id;

      this.amountSpent += this.getPrepaidTransactionAmountSpent(prepaidTransaction);
      this.amountUploaded += this.getPrepaidTransactionAmountUploaded(prepaidTransaction);
      this.amountUnpaid += this.getPrepaidTransactionAmountUnpaid(prepaidTransaction);

      return (
        <tr key={key} className="table__tr-body">
          <td className="table__td-tiny right thin">
            <input type="checkbox" />
          </td>
          <td className="center">{prepaidTransaction.id}</td>
          <td>
            {this.renderPrepaidTransactionInvoice(prepaidTransaction)} <br />
            <span className="lighter">{this.renderPrepaidTransactionType(prepaidTransaction)}</span>
          </td>
          <td className="center">{this.renderPrepaidTransactionUserName(prepaidTransaction)}</td>
          <td className="right">{this.renderPrepaidTransactionAmount(prepaidTransaction)}</td>
          <td>{moment(prepaidTransaction.date).format("DD.MM.YYYY")}</td>
          <td>{this.renderPrepaidTransactionState(prepaidTransaction)}</td>
        </tr>
      );
    });
  }
  renderList() {
    const { t } = this.props;
    const { sortedPrepaidTransactions, userProfile } = this.state;

    this.sumBudget = 0;
    this.sumUnpaid = 0;

    const rows = this.renderRows(sortedPrepaidTransactions);

    if (sortedPrepaidTransactions) {
      return (
        <div>
          <h2 className="">
            <span>
              {t("Credit Transaction Overview")} ({sortedPrepaidTransactions.length})
            </span>
          </h2>
          <table className="dashboard__table">
            <thead>
              <tr className="table__top">
                <td className="table__td-tiny" />
                <td className="table__td-small">{t("Invoice Number")}</td>
                <td>{t("Company Name")}</td>
                <td className="table__td-small">{t("Username")}</td>
                <td className="table__td-medium">{t("Amount")}</td>
                <td className="table__td-small">{t("Created")}</td>
                <td className="table__td-small">{t("Status")}</td>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
            <tfoot>
              <tr>
                <td className="table__td-clear" />
                <td className="table__td-clear" />
                <td className="table__td-clear" />
                <td className="table__td-clear" />
                <td className="right">
                  <strong>
                    {`${
                      formatIntlNumber(this.amountSpent, {
                        language: userProfile?.language
                      }) || 0
                    } / ${formatIntlNumber(this.amountUploaded, {
                      language: userProfile?.language
                    })}`}{" "}
                    €
                  </strong>{" "}
                  <br />
                  <span className="dashboard__text-light">{t("Usage")}</span>
                </td>
                <td className="table__td-clear" />
                <td className="right">
                  <strong>
                    {formatIntlNumber(this.amountUnpaid, {
                      language: userProfile?.language
                    })}{" "}
                    €
                  </strong>{" "}
                  <br />
                  <span className="dashboard__text-light">{t("To Pay")}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      );
    }
  }
  render() {
    const { t } = this.props;
    const { user, userProfile, sortedPrepaidTransactions } = this.state;

    logger.debug("Billing:render", "called: ", this.props);

    if (!user) {
      return <Redirect to="/login" />;
    }

    const orgaId = this.props.match.params.orgaId;
    const orgas = userProfile && userProfile.orgas;

    logger.debug("Billing:render", "orgaId: ", orgaId);

    // TODO: Define permissions role to change this in the near future
    const isRecruiter = orgas?.[orgaId]?.roleName === "RECRUITER";
    if (isRecruiter) {
      return <Redirect to="/" />;
    }

    if (orgaId && orgas && !orgas[orgaId]) {
      return <LoadingView msg={t("No access to organization's invoices")} showSpinner={false} />;
    }

    if (!sortedPrepaidTransactions) {
      return <LoadingView msg={t("Loading invoices...")} showSpinner />;
    }

    return (
      <div className="">
        <section className="dashboard fade-in">
          <div className="">
            {this.renderList()}
            {/* What is this tooltip for? */}
            <ReactTooltip
              place={"top"}
              effect={"solid"}
              type={"info"}
              multiline={true}
              className={"dashboard-tooltip"}
            />
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation()(PrepaidBilling);
